var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLifChain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.41278 17.2319L5.35087 22.8619H1.75098L9.90038 1.38672H11.995H14.0897L22.2381 22.8619H18.5399L11.9613 4.37976L8.39411 14.4016L7.41278 17.2319Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M2.84779 20.0305H0V22.8618H2.84779V20.0305Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M14.2676 2.25953C14.2676 3.50781 9.72217 3.50781 9.72217 2.25953C9.72217 1.66026 9.96162 1.08554 10.3878 0.661801C10.814 0.238057 11.3921 0 11.9949 0C12.5976 0 13.1757 0.238057 13.6019 0.661801C14.0281 1.08554 14.2676 1.66026 14.2676 2.25953Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M24.0001 20.0305H21.1523V22.8618H24.0001V20.0305Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLifChain);
export default __webpack_public_path__ + "static/media/lif-chain.2f4ada28d03608a03c907681f45e3393.svg";
export { ForwardRef as ReactComponent };